// ------------------------------------------------------------------------------------------
// @ PlaceType Actions
// ------------------------------------------------------------------------------------------

import { createAction, props } from '@ngrx/store';

// Load all PlaceTypes
export const loadPlaceTypes = createAction('[PlaceType] Load PlaceTypes');
export const loadPlaceTypesSuccess = createAction(
    '[PlaceType] Load PlaceTypes Success',
    props<{ placetypes: any[] }>()
);
export const loadPlaceTypesFailure = createAction(
    '[PlaceType] Load PlaceTypes Failure',
    props<{ error: string }>()
);

// Load single PlaceType
export const loadPlaceType = createAction(
    '[PlaceType] Load PlaceType',
    props<{ id: number }>()
);
export const loadPlaceTypeSuccess = createAction(
    '[PlaceType] Load PlaceType Success',
    props<{ placetype: any }>()
);
export const loadPlaceTypeFailure = createAction(
    '[PlaceType] Load PlaceType Failure',
    props<{ error: string }>()
);

// Create
export const createPlaceType = createAction(
    '[PlaceType] Create PlaceType',
    props<{ data: string }>()
);
export const createPlaceTypeSuccess = createAction(
    '[PlaceType] Create PlaceType Success',
    props<{ placetype: any; success: string }>()
);
export const createPlaceTypeFailure = createAction(
    '[PlaceType] Create PlaceType Failure',
    props<{ error: string }>()
);

// Update
export const updatePlaceType = createAction(
    '[PlaceType] Update PlaceType',
    props<{ data: string; id: number }>()
);
export const updatePlaceTypeSuccess = createAction(
    '[PlaceType] Update PlaceType Success',
    props<{ placetype: any; success: string }>()
);
export const updatePlaceTypeFailure = createAction(
    '[PlaceType] Update PlaceType Failure',
    props<{ error: string }>()
);

// Delete
export const deletePlaceType = createAction(
    '[PlaceType] Delete PlaceType',
    props<{ id: number }>()
);
export const deletePlaceTypeSuccess = createAction(
    '[PlaceType] Delete PlaceType Success',
    props<{ id: number; success: string }>()
);
export const deletePlaceTypeFailure = createAction(
    '[PlaceType] Delete PlaceType Failure',
    props<{ error: string }>()
);
